import { Permission } from '@cims-online/shared'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { useCreateDsTypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { DSType, useTypesTableContext } from '../../../../TypesTableContext'
import CreateEditFormItems from '../../components/CreateEditFormItems'
import { CreateFormItemsValues } from '../../components/CreateEditFormItems/types'
import { useProjectContext } from 'context/ProjectContext'

export function useCreate(): CreateHeaderActionOptions<DSType> {
  const { projectId } = useProjectContext()
  const { refetch, fetching } = useTypesTableContext()
  const [create] = useCreateDsTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createDSType: {
        type: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    loading: fetching,
    entity: 'Type',
    permission: Permission.CreateDesignSubmittalType,
    modal: {
      type: 'simple',
      body: <CreateEditFormItems />,
      onOk: async ({ name, description }: CreateFormItemsValues) => {
        await create({
          variables: { createDsTypeInput: { projectId, name, description } },
        })
        refetch()
      },
    },
  }
}
